import { UseFormSetValue } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  FieldTemplateGeneric,
  renderFieldTemplateGeneric,
} from "./PlantillasBloquesTabla"

const PlantillaDeclaracionEstandar = ({
  fields,
  setValue,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  fields: FieldTemplateGeneric[]
}) => {
  const { t } = useTranslation()
  return (
    <div className='tw-px-4 tw-w-full'>
      {fields.map((row) => (
        <div
          key={row.id}
          className={`tw-h-fit tw-grid ${
            row?.columsNumber ? row.columsNumber : "tw-grid-cols-4"
          } tw-py-3 tw-gap-7 tw-border-b tw-border-neutral-25`}
        >
          {renderFieldTemplateGeneric({
            fields: row.inputsOne,
            setValue,
            t,
          })}
        </div>
      ))}
    </div>
  )
}
export default PlantillaDeclaracionEstandar
